module.exports = __webpack_public_path__ + "static/media/curbix.b01cd6ef.jpg";